import "./style.css";
import { k } from "./reactive-element-DZ4uc4cT-BmQGLYME-HcXnJBgK-C5QAKziK.js";
import { html as Y, render as ie$1 } from "./index-CYA3oVVY-hqmzhX60-DijabQOP.js";
import "./lit-element-Bwc3Q88e-BvvsTfdo-Ch2fLuxu-B39NhNnt.js";
import { property as h } from "./index-s3jJ0xl5-CowEOooj-Bsetjq7R.js";
import { state as a } from "./index-uiGwYmGU-B4gTdfzL-u5nzwjdz.js";
import { query as d } from "./index-DkrD1O-0-BhoO1gJQ-MvFrwQhi.js";
import { map as n } from "./index-CSPViVrn-qlGozkNP-DvXCEfLV.js";
import { E as E$1, u as u$1, n as ne$1 } from "./abstract-base-hYnPtNku-DvWH8d8i-lRUZ3Vlj-By8JIbn5.js";
import { _e as ie, r as l } from "./index-Dkv99wmd-BkVwFZyn-Caa3rfMw.js";
import { fe as oe$1, p as c, H as L$1 } from "./index-Dc5IVl1D-CqOsliWT-BtNKLP_o.js";
import { k as Z, i as s } from "./index-e1bYYYyL-DF8I9dNo-Dkqjh0Yg.js";
import { B } from "./mixin-CF2SvUAD-CP6jLr_x-B2kii9MW-B5IwBsZY.js";
import { S as S$1 } from "./watch-media-BqixTNFk-CPwyDPdR-MYbNKw_l-ChTwH0EJ.js";
import { u } from "./cache-k_Y4WfzP-6JTXDgYZ-BwRi7Jyn-AZ7RJnZm.js";
import { x } from "./lifecycle-decorators-Cg3csm0R-CIqP0clw-Dtq_Oc7c-B_fw4Bcc.js";
import { d as d$1 } from "./scrollableRegion-Cbxt6UUr-_fwWmTTs-BkxBpqYt-XrQqCpcI.js";
import { t as t$1 } from "./uid-HAKIZOcY-BMoifg7G-DGLBmjXH-CW5geV_y.js";
var se = (e) => {
  throw TypeError(e);
}, U = (e, a2, t) => a2.has(e) || se("Cannot " + t), C = (e, a2, t) => (U(e, a2, "read from private field"), t ? t.call(e) : a2.get(e)), D = (e, a2, t) => a2.has(e) ? se("Cannot add the same private member more than once") : a2 instanceof WeakSet ? a2.add(e) : a2.set(e, t), $ = (e, a2, t, n2) => (U(e, a2, "write to private field"), a2.set(e, t), t), L = (e, a2, t) => (U(e, a2, "access private method"), t), F = /* @__PURE__ */ ((e) => (e.MOVABLE = "movable", e.FIXED = "fixed", e.FLOATING = "floating", e))(F || {});
function ee(e, a2, t) {
  e != 0 ? a2 == null || a2.classList.add(t) : a2 == null || a2.classList.remove(t);
}
const ge = "td", fe = "table";
function ve(e) {
  var a2;
  if (!e) return;
  const t = e.closest(ge);
  if (!t) return;
  const n2 = Array.prototype.indexOf.call(
    (a2 = t == null ? void 0 : t.parentNode) == null ? void 0 : a2.children,
    t
  );
  if (!n2) return;
  const o = t.closest(fe);
  if (!o || !o.rows) return;
  let r = 0, s2;
  for (s2 = 0; r <= n2; s2 += 1) {
    const c2 = o.rows[0].cells[s2];
    if (!c2) break;
    c2.dataset.colSpan ? r += parseInt(c2.dataset.colSpan, 10) : r += c2.colSpan;
  }
  return o.rows[0].cells[s2 - 1];
}
const ye = k`:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][beacon-tag-name=beacon-table],[beacon-version="4.2.2"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-3);--table-caption-summary-spacer: var(--beacon-reference-space-5);--table-caption-spacer-jumbo: var(--beacon-reference-space-5);--table-caption-spacer-normal: var(--beacon-reference-space-3);--table-row-space-padding: var(--beacon-reference-space-2)}@media (width >= 640px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][beacon-tag-name=beacon-table],[beacon-version="4.2.2"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-4);--table-row-space-padding: var(--beacon-reference-space-3)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][beacon-tag-name=beacon-table],[beacon-version="4.2.2"] [beacon-tag-name=beacon-table]{--table-caption-summary-spacer: var(--beacon-reference-space-7);--table-caption-spacer-jumbo: var(--beacon-reference-space-7);--table-caption-spacer-normal: var(--beacon-reference-space-5);--table-row-space-padding: var(--beacon-reference-space-4)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-table],:root [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-table],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-table],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-table],[beacon-version="4.2.2"][beacon-tag-name=beacon-table],[beacon-version="4.2.2"] [beacon-tag-name=beacon-table]{--table-space-padding: var(--beacon-reference-space-2)}}`, ae = {
  beaconTagName: "beacon-table"
}, ke = {
  Standard: "standard",
  Compact: "compact",
  Comfortable: "comfortable"
}, we = k`[beacon-tag-name=beacon-table]{--layer-base: 1;--layer-headers: calc(var(--layer-base) + 1);--layer-headers-sticky: calc(var(--layer-headers) + 1);--layer-popover: calc(var(--layer-headers-sticky) + 1);--table-thead-position: sticky;background-color:transparent}[beacon-tag-name=beacon-table][static-header]{--table-thead-position: relative;--layer-headers: auto}[beacon-tag-name=beacon-table]:is(.beacon-on-light,.beacon-on-dark){background-color:transparent}[beacon-tag-name=beacon-table] .beacon-table{box-sizing:border-box;border:inherit;color:inherit;letter-spacing:inherit;line-height:inherit;white-space:inherit;word-spacing:inherit;font-family:inherit;font-size:inherit;font-style:inherit;font-variant:inherit;font-weight:inherit;text-align:inherit;text-indent:inherit;text-transform:inherit;background-color:var(--beacon-system-color-background-1);border-collapse:separate;border-spacing:0;min-inline-size:100%;overflow-wrap:break-word;position:relative;table-layout:var(--beacon-table-layout, fixed)}[beacon-tag-name=beacon-table] .beacon-table *,[beacon-tag-name=beacon-table] .beacon-table *:after,[beacon-tag-name=beacon-table] .beacon-table *:before{box-sizing:inherit}[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){[beacon-tag-name=beacon-table] .beacon-table:not(.container-has-border){border-radius:var(--beacon-system-radius-corner-standard)}}[beacon-tag-name=beacon-table] .beacon-table.container-has-left-border{border-inline-start:none}[beacon-tag-name=beacon-table] .beacon-table.container-has-right-border{border-inline-end:none}[beacon-tag-name=beacon-table] .beacon-table a{color:var(--beacon-system-color-text-link)}[beacon-tag-name=beacon-table] .beacon-table caption{background-color:var(--beacon-system-color-background-1);padding-block-end:var(--beacon-reference-space-5);text-align:start}[beacon-tag-name=beacon-table] .beacon-table thead{inset-block-start:0;position:var(--table-thead-position);z-index:var(--layer-headers)}[beacon-tag-name=beacon-table] .beacon-table :is(th,td){--cell-color: var(--beacon-system-color-text-standard);--cell-text-alignment: initial;--modern-outlook-table-cell-padding: calc(var(--beacon-component-table-space-cell) + var(--beacon-system-space-cell-contained));background-color:var(--beacon-system-color-background-1);color:var(--cell-color);padding-block:var(--modern-outlook-table-cell-padding);padding-inline:var(--modern-outlook-table-cell-padding);position:relative;text-align:var(--cell-text-alignment);vertical-align:top}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot){--divider-border-color: var(--beacon-component-table-color-border)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) :is(th,td){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table] .beacon-table :is(tbody,tfoot) th{--cell-text-alignment: start}[beacon-tag-name=beacon-table] .beacon-table tbody th:after{border-block-end:var(--inset-divider-border);content:"";display:block;margin-block:0;margin-inline:var(--inset-divider-margin-start) var(--inset-divider-margin-end);padding-block-start:var(--inset-divider-padding-block-start)}[beacon-tag-name=beacon-table] .beacon-table thead th{--cell-background: var(--beacon-system-color-background-2);--cell-color: var(--beacon-system-color-text-standard);--divider-border-color: var(--beacon-component-table-color-border);background-color:var(--cell-background);font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-caption-200)}[beacon-tag-name=beacon-table] .beacon-table thead th[colspan]{padding-block-end:var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table] .beacon-table thead th:not([colspan]),[beacon-tag-name=beacon-table] .beacon-table thead th[colspan][has-dropdown]{border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:not(:first-of-type) th,[beacon-tag-name=beacon-table] .beacon-table thead tr:first-of-type th:not(:last-of-type){border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:first-child{border-start-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table thead tr:first-child th:last-child{border-start-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child th:first-child{border-end-start-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:last-child td:last-child{border-end-end-radius:var(--beacon-system-radius-corner-standard)}[beacon-tag-name=beacon-table] .beacon-table tbody tr:not(:last-of-type)>:is(th,td){border-block-end-color:var(--divider-border-color);border-block-end-style:var(--border-style);border-block-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tfoot tr>:is(th,td){border-block-start-color:var(--divider-border-color);border-block-start-style:var(--border-style);border-block-start-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table] .beacon-table tr:is([data-beacon-selected],[data-beacon-highlighted]) th:first-of-type:before{background-color:var(--beacon-system-color-border-brand);block-size:100%;content:"";display:block;inline-size:var(--beacon-system-width-border-jumbo);inset-block-start:0;inset-inline-start:0;position:absolute}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-highlighted] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table tr[data-beacon-selected] :is(th:first-of-type,td){background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-highlighted] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-stub-column tr[data-beacon-selected] th:first-of-type{background-color:var(--beacon-component-table-color-background-selected)}[beacon-tag-name=beacon-table] .beacon-table.has-sticky-header thead{z-index:var(--layer-headers-sticky)}[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end th,[beacon-tag-name=beacon-table] .beacon-table tr.remove-border-block-end td{border-block-end-color:transparent!important}[beacon-tag-name=beacon-table][multi-level] .beacon-table :is(tbody,tfoot) th{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{inset-inline-start:0;position:sticky}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th{z-index:var(--layer-base)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table :is(tbody,tfoot) th:has([is-open]){z-index:var(--layer-popover)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table thead tr:first-of-type th:first-of-type{z-index:var(--layer-headers)}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column{--sticky-cell-elevation: auto;--sticky-cell-elevation-stub: auto}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type{filter:drop-shadow(var(--sticky-cell-elevation, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end:0;filter:drop-shadow(var(--sticky-cell-elevation-stub, none))}[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column :is(tbody,tfoot) tr th:first-of-type,[beacon-tag-name=beacon-table][variant=fixed] .beacon-table.has-sticky-stub-column thead tr:first-of-type th:first-of-type{border-inline-end-color:var(--divider-border-color);border-inline-end-style:var(--border-style);border-inline-end-width:var(--beacon-system-width-border-mini)}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub{--table-stub-floating-override-margin-inline-start: 0%}[beacon-tag-name=beacon-table][variant=floating] .beacon-table.floating-stub :is(tbody,tfoot) th{padding:0}[beacon-tag-name=beacon-table] [data-beacon-sort-state=false] [data-beacon-sort]{display:none}[beacon-tag-name=beacon-table] [data-beacon-sort]{--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-5);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-5)}[beacon-tag-name=beacon-table] [data-beacon-sort] svg{fill:var(--beacon-system-color-icon-tertiary)}[beacon-tag-name=beacon-table] [aria-sort=ascending] [data-beacon-sort] svg:not(.ascending){display:none}[beacon-tag-name=beacon-table] [aria-sort=descending] [data-beacon-sort] svg:not(.descending){display:none}[beacon-tag-name=beacon-table] [aria-sort]:not([aria-sort=none]){background-color:var(--beacon-system-color-background-1)}[beacon-tag-name=beacon-table] th:is(:not([aria-sort]),[aria-sort=none]) [data-beacon-sort] svg:not(.default){display:none}[beacon-tag-name=beacon-table][sortable] .beacon-table :is(td,th)[data-beacon-sorted=true]{font-weight:var(--beacon-system-font-weight-bold)}`, Ce = k`:host{--border-style: solid;word-break:initial}.table-container{block-size:var(--beacon-custom-table-container-block-size, auto);display:var(--table-container-display, block);inline-size:var(--beacon-custom-table-container-inline-size, auto);margin-inline:var(--inline-margin, 0);overflow-x:var(--beacon-custom-table-container-overflow-x, initial);scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track)}.table-container::-webkit-scrollbar{block-size:calc(var(--beacon-reference-space-3) * .75);inline-size:calc(var(--beacon-reference-space-3) * .75)}.table-container::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);border-radius:calc(.875 * var(--beacon-reference-space-5))}.table-container::-webkit-scrollbar-track{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container::-webkit-scrollbar-corner{background:var(--beacon-reference-palette-grayscale-light-gray-1)}.table-container.full-bleed{--inline-margin: calc(50% - 50vw) }.table-container.add-full-border{border-color:var(--beacon-component-table-color-border);border-radius:var(--beacon-system-radius-corner-standard);border-style:var(--border-style, solid);border-width:var(--beacon-system-width-border-mini)}@media (width >= 640px){.table-container.add-full-border{border-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-bottom-border{border-block-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-bottom-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-end-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-left-border{border-inline-start:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-left-border{border-end-start-radius:var(--beacon-system-radius-corner-standard);border-start-start-radius:var(--beacon-system-radius-corner-standard)}}.table-container.add-right-border{border-inline-end:var(--beacon-system-width-border-mini) var(--border-style, solid) var(--beacon-component-table-color-border)}@media (width >= 640px){.table-container.add-right-border{border-end-end-radius:var(--beacon-system-radius-corner-standard);border-start-end-radius:var(--beacon-system-radius-corner-standard)}}.transformed-cards{--beacon-body-font-size-100: var(--beacon-reference-space-4);--table-override-header-sort-icon-display: none;--table-override-header-wrapper-inline-size: fit-content;--table-override-stub-action-zone-right-space: 0;--table-override-stub-content-space-margin-inline-start: 0;--table-override-stub-dropdown-display: none;--table-override-header-dropdown-display: none;display:var(--transformed-cards-display, none)}.transformed-cards [beacon-tag-name=beacon-table-header]{--text-cell-padding-inline-start: 0;font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200)}.transformed-cards [beacon-tag-name=beacon-table-header]::part(text-cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100);margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell){padding:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(cell-wrapper){margin-inline:0}.transformed-cards [beacon-tag-name=beacon-table-record]::part(action-zone){margin-inline-start:var(--beacon-reference-space-3)}.transformed-cards [beacon-tag-name=beacon-table-stub]{--stub-content-margin-inline-end: 0;--stub-content-margin-inline-start: 0}.transformed-cards [beacon-tag-name=beacon-table-stub]::part(content){padding:0}.transformed-cards [beacon-tag-name=beacon-table-header],.transformed-cards [beacon-tag-name=beacon-table-record],.transformed-cards .stub,.transformed-cards .header,.transformed-cards .record{color:var(--beacon-system-color-text-standard);font-size:var(--beacon-reference-space-4)}.transformed-cards .card{background-color:var(--beacon-system-color-background-primary);border-radius:var(--beacon-system-radius-corner-circle);display:grid;gap:var(--beacon-reference-space-5);padding:var(--beacon-reference-space-5)}.transformed-cards .card:not(:last-of-type){margin-block-end:var(--beacon-reference-space-5)}.transformed-cards .card .stub{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.transformed-cards .card-data{display:grid;font-size:var(--beacon-reference-space-3);gap:var(--beacon-reference-space-5)}.transformed-cards .card-row{padding-block-end:var(--padding-block-end)}.transformed-cards .card-row .header{flex:1;line-height:1.6}.transformed-cards .card-row .record{font-weight:var(--beacon-system-font-weight-bold);line-height:1.43}.transformed-cards .card-row:not(.grouped){align-items:center}.transformed-cards .card-row.grouped{--padding-block-end: var(--beacon-reference-space-5);display:flex;flex-direction:column}.transformed-cards .card-row:not(:last-of-type){border-block-end:var(--beacon-system-width-border-mini) solid var(--beacon-system-color-border-secondary)}.transformed-cards .card-row.single{--padding-block-end: var(--beacon-reference-space-5)}.transformed-cards .grid{display:grid;grid-template-columns:1fr 1fr}.transformed-cards .grid .record,.transformed-cards .grid [beacon-tag-name=beacon-table-record]{justify-self:end}.transformed-cards .header-children :is(.header,[beacon-tag-name=beacon-table-header]){text-indent:var(--beacon-reference-space-5)}:host([is-scrolling-block]) .table-container{block-size:calc(var(--js-component-size-block) - var(--table-space-padding) * 4)}:host([use-cards]){--table-container-display: none;--transformed-cards-display: block}:host([use-cards]) a{color:var(--beacon-system-color-text-link)}@media (width >= 640px){.table-container.full-bleed{--inline-margin: 0}:host([use-cards]){--table-container-display: block;--transformed-cards-display: none}}`;
var Se = Object.defineProperty, xe = Object.getOwnPropertyDescriptor, g = (e, a2, t, n2) => {
  for (var o = n2 > 1 ? void 0 : n2 ? xe(a2, t) : a2, r = e.length - 1, s2; r >= 0; r--)
    (s2 = e[r]) && (o = (n2 ? s2(a2, t, o) : s2(o)) || o);
  return n2 && o && Se(a2, t, o), o;
}, S, E, M, T, i, te, ne, R, j, V, oe;
const p = (i = class extends B(ne$1).with(S$1) {
  constructor() {
    super(...arguments), D(this, R), D(this, S), D(this, E), D(this, M), this.beaconTagName = ae.beaconTagName, this.deferOptions = { rootMargin: "3000px" }, $(this, S, {
      stickyStub: "has-sticky-stub-column",
      stickyHeader: "has-sticky-header",
      lightDOMTable: "beacon-table",
      floatingStub: "floating-stub"
    }), this.variant = F.MOVABLE, this.sortable = false, this.useCards = false, this.hasMultiLevel = false, this.mobileFullBleed = false, this.density = ke.Standard, this.staticHeader = false, this.scrollPositionBlock = 0, this.scrollPositionInline = 0, $(this, M, false), this.sortRows = (e) => {
      var a2, t, n2;
      const { target: o } = e;
      if (!o) return;
      this.mutationObserver.disconnect(), this.querySelectorAll("[aria-sort]").forEach((s2) => {
        var c2;
        o !== s2 && L(c2 = i, T, V).call(c2, s2, "none");
      });
      let r;
      if (o instanceof oe$1) {
        const s2 = o.parentElement, c2 = (a2 = this.table) == null ? void 0 : a2.querySelector("tbody"), l2 = s2 instanceof HTMLTableCellElement;
        if (!s2 || !c2 || !l2)
          return;
        const b = i.getOrderedHeaders(this.headers);
        if (o.dropdown && o.selectedValue) {
          const m = o.selectedValue;
          r = b.map((k2) => k2.id).indexOf(m);
        } else
          r = b.indexOf(
            s2
          );
        const d2 = i.sortRowData(
          this,
          c2,
          o,
          r
        );
        i.renderSortedRows(c2, d2);
        const h2 = e.target instanceof oe$1 ? (t = e == null ? void 0 : e.detail) == null ? void 0 : t.id : null;
        this.updateSortAttributes(h2);
      } else {
        const s2 = o, c2 = (n2 = this.table) == null ? void 0 : n2.tBodies[0];
        r = i.getOrderedHeaders(this.headers).indexOf(
          s2
        );
        const l2 = i.sortRowData(
          this,
          c2,
          s2,
          r
        );
        i.renderSortedRows(c2, l2);
      }
    }, this.mutationObserver = new MutationObserver(
      (e) => {
        const a2 = ["table", "thead", "tbody", "tr"];
        e.forEach((t) => {
          const { target: n2, type: o } = t;
          o === "childList" && (n2.assignedSlot || a2.includes(n2.nodeName.toLowerCase())) && this.renderTransformedCards();
        });
      }
    ), this.compare = (e, a2) => C(this, E) === c.ASCENDING ? e.value === a2.value ? 0 : typeof e.value == "number" && typeof a2.value == "number" ? e.value - a2.value : e.value < a2.value ? -1 : 1 : C(this, E) === c.DESCENDING ? e.value === a2.value ? 0 : typeof e.value == "number" && typeof a2.value == "number" ? a2.value - e.value : e.value > a2.value ? -1 : 1 : 0;
  }
  static get styles() {
    return [super.styles, Ce];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, we, ye];
  }
  get headers() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("thead th");
  }
  get stubs() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("tbody tr th:first-of-type");
  }
  get records() {
    var e;
    return (e = this.table) == null ? void 0 : e.querySelectorAll("td");
  }
  get table() {
    return u(
      this,
      "_table",
      () => this.querySelector("table")
    );
  }
  static getSortValue(e) {
    const { firstElementChild: a2 } = e;
    return a2 instanceof Z ? L(this, T, te).call(this, a2) : L(this, T, ne).call(this, e);
  }
  /**
   * Iterates through a Nodelist of BeaconTableRecords and sets 'bold' prop to false.
   * Otherwise, updates the data attribute from standard table cells.
   * @param tableRecords list of Elements
   */
  static resetRecordBoldSortStyles(e) {
    e.forEach((a2) => {
      a2.firstElementChild instanceof Z ? a2.firstElementChild.sorted = false : a2.dataset.beaconSorted = "false";
    });
  }
  /**
   * Sorts the `<tr>` 'rowNodes' of a `<tbody>` element. It retrieves sorting criteria from a BeaconTableHeader and sorts all records in a given column.
   * The function has several sorting exceptions for unsortable elements such as level-2 and level-3 BeaconTableStubs and their respective rows which
   * must remain directly below their parental level-1 BeaconTableStub and its row.
   * @param tableBodyElement a `<tbody>` element
   * @param tableHeaderElement a BeaconTableHeader
   * @param columnIndex index of the column where records are sorted
   * @returns a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   *
   * @todo: Need a concrete API decision for how to distinguish the different levels of stubs so native tables can account for them in sorting
   */
  static sortRowData(e, a2, t, n2) {
    const o = [], r = [], s2 = /* @__PURE__ */ new WeakMap(), c2 = /* @__PURE__ */ new WeakMap();
    let l$1 = 0, b = a2 == null ? void 0 : a2.firstElementChild, d2 = null, h2 = null, m = [];
    for (; b; ) {
      const f = b.querySelectorAll("th, td"), u2 = f[0].firstElementChild;
      i.resetRecordBoldSortStyles(f);
      const w = f[n2], y = w.firstElementChild;
      if (y instanceof Z ? y.sorted = true : w.dataset.beaconSorted = "true", u2 instanceof ie && u2.level === l.ONE || !(u2 instanceof ie)) {
        h2 && m.length && (c2.set(h2, [
          ...m
        ]), h2 = null, m = []), o.push(b);
        const H = i.getSortValue(w), I = {
          index: l$1,
          value: H
        };
        r.push(I), l$1 += 1;
      }
      u2 instanceof ie && (u2.level === l.ONE && (d2 = u2), u2.level === l.TWO && d2 && (h2 = u2, s2.set(
        d2,
        u2
      )), u2.level === l.THREE && h2 && m.push(u2)), b = b.nextElementSibling;
    }
    h2 && m.length && c2.set(h2, [
      ...m
    ]);
    const k2 = {
      levelOne: s2,
      levelTwo: c2
    }, v = t instanceof oe$1 ? t.compare : e.compare;
    return r.sort(v), {
      rowNodes: o,
      dataCells: r,
      tableStubMap: k2
    };
  }
  /**
   * Rendering function that appends the sorted rowNode `<tr>`s to the `<tbody>`.
   * @param tableBodyElement a `<tbody>` element
   * @param sortData a TableSortingData Object that contains a sorted dataCells array, an array of rowNodes and a WeakMap of level-1/level-2 BeaconTableStub relationships
   * to preserve level-2 and level-3 hierarchies under level-1 BeaconTableStub rows.
   */
  static renderSortedRows(e, a2) {
    const { rowNodes: t, dataCells: n2, tableStubMap: o } = a2;
    !n2 || !t.length || n2.forEach((r) => {
      var s2, c2;
      if (r) {
        const l$1 = t[r.index], b = (s2 = l$1.firstElementChild) == null ? void 0 : s2.firstElementChild;
        if (e == null || e.appendChild(l$1), b instanceof ie && b.level === l.ONE) {
          const d2 = o.levelOne.get(
            b
          ), h2 = (c2 = d2 == null ? void 0 : d2.parentElement) == null ? void 0 : c2.parentElement;
          if (d2 && h2) {
            e == null || e.appendChild(h2);
            const m = o.levelTwo.get(d2);
            m && m.length && m.forEach(
              (k2) => {
                var v;
                const f = (v = k2.parentElement) == null ? void 0 : v.parentElement;
                f && (e == null || e.appendChild(
                  f
                ));
              }
            );
          }
        }
      }
    });
  }
  /**
   * A function that takes a NodeList of header TableCellElements sifts through them in search of nested headers.
   * When it finds nestedHeaders it splices them in the appropriate column order so that each header's index matches
   * its corresponding column of tableRecords.
   * @param headersNodeList a Nodelist of `<th>`'s
   * @returns sorted array of headers.
   */
  static getOrderedHeaders(e) {
    const a2 = [], t = {};
    e == null || e.forEach((n2) => {
      n2 instanceof HTMLTableCellElement && (n2.headers ? t[n2.headers] ? t[n2.headers].push(n2) : t[n2.headers] = [n2] : a2.push(n2));
    });
    for (const [n2, o] of Object.entries(t)) {
      const r = a2.map((s2) => s2.id).indexOf(n2);
      a2.splice(r, 1, ...o);
    }
    return a2;
  }
  /** Attribute triggers vertical-divider styles for `<th>` elements in `<tbody>` in multi-level stub context. */
  _setMultiLevelAttribute() {
    this.toggleAttribute("multi-level", this.hasMultiLevel);
  }
  // this is called by table stubs
  _setMultiLevel(e) {
    this.hasMultiLevel = e;
  }
  /** Receive scroll events on the component and set scroll position states. */
  captureScrollPosition(e) {
    var a2, t, n2;
    const { target: o } = e, { scrollLeft: r, scrollTop: s2 } = o;
    if (this.scrollPositionInline = r, this.scrollPositionBlock = s2, this.variant === F.FLOATING) {
      const c2 = (t = (a2 = this.table) == null ? void 0 : a2.querySelector("thead th")) == null ? void 0 : t.clientWidth, l2 = Math.abs(this.scrollPositionInline) + "px";
      this.style.setProperty(
        "--table-stub-floating-override-inset-inline-start",
        l2
      ), c2 && c2 * 0.8 < this.scrollPositionInline ? this.table.classList.add(C(this, S).floatingStub) : (n2 = this.table) == null || n2.classList.remove(C(this, S).floatingStub);
    }
    this.variant === F.FIXED && ee(
      this.scrollPositionInline,
      this.table,
      C(this, S).stickyStub
    ), ee(
      this.scrollPositionBlock,
      this.table,
      C(this, S).stickyHeader
    ), this.updateTableBorders();
  }
  getTableAndContainerRects() {
    var e, a2, t;
    const n2 = (a2 = (e = this.table) == null ? void 0 : e.getBoundingClientRect()) != null ? a2 : new DOMRect(), o = this.tableContainer.getBoundingClientRect(), r = n2.top - o.top, s2 = n2.left - o.left, c2 = n2.right - o.right, l2 = n2.bottom, b = o.bottom - l2, d2 = (t = this.table) == null ? void 0 : t.querySelector("caption");
    let h2 = 0;
    return d2 && (h2 = d2.getBoundingClientRect().top - o.top), {
      tableRect: n2,
      containerRect: o,
      tableDistanceFromContainerTop: r,
      tableDistanceFromContainerLeft: s2,
      tableDistanceFromContainerRight: c2,
      distanceFromContainerBottom: b,
      captionElement: d2,
      captionDistanceFromContainerTop: h2
    };
  }
  addContainerLeftRightBorders({
    tableDistanceFromContainerLeft: e,
    tableDistanceFromContainerRight: a2
  }) {
    var t, n2;
    this.tableContainer.classList.toggle(
      "add-left-border",
      e < 0
    ), (t = this.table) == null || t.classList.toggle(
      "container-has-left-border",
      e < 0
    ), this.tableContainer.classList.toggle(
      "add-right-border",
      a2 >= 0
    ), (n2 = this.table) == null || n2.classList.toggle(
      "container-has-right-border",
      a2 >= 0
    );
  }
  /**
   * Updates the table borders based on the table and container bounding rectangles
   */
  updateTableBorders() {
    var e, a2, t, n2, o, r, s2, c2, l2;
    const {
      containerRect: b,
      tableDistanceFromContainerTop: d2,
      tableDistanceFromContainerLeft: h2,
      tableDistanceFromContainerRight: m,
      captionElement: k2,
      captionDistanceFromContainerTop: v
    } = this.getTableAndContainerRects(), f = (a2 = (e = this.table) == null ? void 0 : e.querySelector("thead")) == null ? void 0 : a2.getBoundingClientRect(), u2 = (n2 = (t = this.table) == null ? void 0 : t.querySelector("tbody")) == null ? void 0 : n2.getBoundingClientRect(), w = f ? f.top - b.top : u2 ? u2.top - b.top : 0;
    k2 ? (v <= 0 && w === 0 && (this.tableContainer.classList.contains("add-full-border") || this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (o = this.table) != null && o.classList.contains("container-has-border") || (r = this.table) == null || r.classList.add("container-has-border")), v <= 0 && w > 1 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (s2 = this.table) == null || s2.classList.remove("container-has-border"))) : (w <= 0 && d2 < 0 && (this.tableContainer.classList.add("add-full-border"), this.tableContainer.classList.remove("add-bottom-border"), (c2 = this.table) == null || c2.classList.add("container-has-border")), d2 >= 0 && (this.tableContainer.classList.remove("add-full-border"), this.tableContainer.classList.add("add-bottom-border"), (l2 = this.table) == null || l2.classList.remove("container-has-border"))), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: h2,
      tableDistanceFromContainerRight: m
    });
  }
  /** Adds a bottom, left or right border to the table container on initial load if the table overflows. */
  addContainerBorders() {
    const {
      distanceFromContainerBottom: e,
      tableDistanceFromContainerLeft: a2,
      tableDistanceFromContainerRight: t
    } = this.getTableAndContainerRects();
    e < 0 && this.tableContainer.classList.add("add-bottom-border"), this.addContainerLeftRightBorders({
      tableDistanceFromContainerLeft: a2,
      tableDistanceFromContainerRight: t
    });
  }
  /** Handler to render transformed cards when table is resized to mobile view. */
  _handleBreakpointChanges() {
    this.isMediumBreakpoint || (this.renderTransformedCards(), this.table && this.mutationObserver.observe(this.table, {
      childList: true,
      characterData: true,
      subtree: true
    }));
  }
  /**
   * Creates content for the cards from the stub, header, or record parent elements.
   * @param start Element to use as the reference node
   * @param type The type of component the final result is, such as 'stub' or 'header' or 'record'
   * @returns A new element made from the children of the starting element
   */
  static generateCardContent(e, a2) {
    const t = document.createElement("div"), n2 = Array.from(
      e.childNodes,
      (s2) => s2.cloneNode(true)
    );
    n2 && t.append(...n2);
    const o = t$1(), r = "uuid";
    return e.setAttribute(r, o), t.setAttribute(r, o), t.classList.add(a2), t;
  }
  /**
   * Clones a Beacon Table Cell and changes its state.
   * @param component Beacon Table component to be cloned
   * @returns Clone of the node with its state changed
   */
  static cloneComponent(e) {
    const a2 = e.cloneNode(true);
    return a2.isOriginal = false, a2;
  }
  /** For mobile card view, iterate over all child components and clone them into cards. */
  async renderTransformedCards() {
    await this.updateComplete;
    const e = "stub", a2 = "header", t = "record", n$1 = n(
      this.stubs,
      (o) => {
        if (!this.records) return;
        const r = Array.from(this.records).filter(
          (l2) => {
            var b;
            return (b = o.parentNode) == null ? void 0 : b.contains(l2);
          }
        ), s2 = o.querySelector(
          this.getScopedTagName("beacon-table-stub")
        ), c2 = s2 ? i.cloneComponent(s2) : i.generateCardContent(o, e);
        return Y`
          <div class="card">
            ${c2}
            <div class="card-data">
              ${n(
          this.headers,
          (l2, b) => {
            if (!this.records || b === 0) return;
            let d2 = Y``, h2 = "single grid", m;
            const k2 = Array.from(this.records).filter(
              (y) => ve(y) === l2
            );
            if (!k2) return d2;
            const v = k2.find(
              (y) => r.includes(y)
            );
            if (!v) return d2;
            const f = L$1(
              l2,
              false,
              false,
              ["th"]
            ), u2 = l2.querySelector(
              this.getScopedTagName("beacon-table-header")
            ), w = u2 ? i.cloneComponent(u2) : i.generateCardContent(l2, a2);
            if (f && f.length > 0)
              h2 = "grouped", d2 = Y`${w}
                    ${n(
                f,
                (y, H) => {
                  const I = r.indexOf(v) + H, X = r[I], Y$1 = y.querySelector(
                    this.getScopedTagName("beacon-table-header")
                  ), ce = Y$1 ? i.cloneComponent(Y$1) : i.generateCardContent(
                    y,
                    a2
                  ), J = X.querySelector(
                    this.getScopedTagName("beacon-table-record")
                  );
                  return m = J ? i.cloneComponent(J) : i.generateCardContent(
                    X,
                    t
                  ), Y`
                          <div class="header-children grid">
                            ${ce} ${m}
                          </div>
                        `;
                }
              )} `;
            else {
              const y = v.querySelector(
                this.getScopedTagName("beacon-table-record")
              );
              m = y ? i.cloneComponent(y) : i.generateCardContent(
                v,
                t
              ), d2 = Y` ${w} ${m} `;
            }
            return Y`
                    <div class="card-row ${h2}">${d2}</div>
                  `;
          }
        )}
            </div>
          </div>
        `;
      }
    );
    ie$1(n$1, this._transformedCardsContainer), E$1(this, u$1.RENDER_TABLE_CARDS), this.triggerRecordActionZoneStatus();
  }
  /**
   * Manually calls `setActionZoneStatus` on each BeaconTableRecord component in the cards to make sure the slot area is visible or hidden as needed.
   */
  async triggerRecordActionZoneStatus() {
    this._transformedCardsContainer.querySelectorAll(
      this.getScopedTagName("beacon-table-record")
    ).forEach(
      async (e) => {
        await e.updateComplete, e.setActionZoneStatus();
      }
    );
  }
  _handleCardChanges() {
    this.isMobile && this.renderTransformedCards();
  }
  _handleSortChanges() {
    this.sortable ? L(this, R, oe).call(this) : L(this, R, j).call(this);
  }
  /**
   * This updates sort-inactive attributes on all BeaconTableHeaders except the one that triggered the sort event.
   * @param targetId Id of BeaconTableHeader that triggered the sort event
   */
  updateSortAttributes(e) {
    var a2;
    const t = this.querySelectorAll(
      this.getScopedTagName("beacon-table-header")
    );
    for (const n2 of t)
      ((a2 = n2.parentElement) == null ? void 0 : a2.id) !== e && n2.resetSortedAttr();
  }
  // Not using @prerender here because table needs to be able to sort in defer-until=visible context.
  connectedCallback() {
    setTimeout(
      () => this.addEventListener(
        u$1.SORT,
        this.sortRows
      ),
      100
    ), super.connectedCallback();
  }
  async firstUpdated() {
    this.table && (this.table.classList.add(C(this, S).lightDOMTable), await this.updateComplete, this.useCards && this.isMobile && (this.renderTransformedCards(), this.mutationObserver.observe(this.table, {
      childList: true,
      characterData: true,
      subtree: true
    })), this.addContainerBorders()), super.firstUpdated();
  }
  render() {
    return Y`
      <div class="transformed-cards"></div>
      <div
        class="table-container ${this.mobileFullBleed ? "full-bleed" : "contained"}"
        tabindex=${d$1()}
        @scroll=${this.captureScrollPosition}>
        <slot></slot>
      </div>
    `;
  }
}, S = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap(), M = /* @__PURE__ */ new WeakMap(), T = /* @__PURE__ */ new WeakSet(), te = function(e) {
  const { variant: a2, sortValue: t } = e;
  return t && (a2 === s.NUMERAL || a2 === s.DATE) ? parseFloat(t) : t;
}, ne = function(e) {
  var a2;
  const {
    innerText: t,
    dataset: { beaconSortValue: n2, beaconSortType: o }
  } = e, r = (a2 = t == null ? void 0 : t.toLowerCase().trim()) != null ? a2 : "";
  return o === "number" ? parseFloat(n2 || r) : n2 != null ? n2 : r;
}, R = /* @__PURE__ */ new WeakSet(), /** Updates the sort state for sortable headers that aren't a BeaconTableHeader. */
j = function() {
  const e = this.querySelectorAll(
    "[data-beacon-sort-state]"
  );
  for (const a2 of e)
    a2.dataset.beaconSortState = String(this.sortable);
}, V = function(e, a2) {
  const t = e.querySelector("[data-beacon-sort]"), n2 = t == null ? void 0 : t.querySelector(".sort-text");
  if (n2) {
    switch (a2) {
      case "ascending":
      case "descending":
        n2.innerHTML = `Sorted ${a2}`;
        break;
      case "none":
        n2.innerHTML = "Sort";
        break;
    }
    e.setAttribute("aria-sort", a2);
  }
}, oe = function() {
  if (L(this, R, j).call(this), C(this, M)) return;
  const e = this.querySelector("thead"), a2 = e == null ? void 0 : e.querySelectorAll("th"), t = document.createElement("template");
  t.innerHTML = `
      <style>
        .base {
          display: grid;
          grid-template-columns: 1fr auto;
        }
      </style>
      <div class="base">
        <div class="default-slot"><slot></slot></div>
        <div class="sort-row"><slot name="sort"></slot></div>
      </div>
    `, a2 == null || a2.forEach((n2) => {
    if (!("beaconSortable" in n2.dataset)) return;
    const o = document.createElement("div");
    o.dataset.beaconSortState = String(this.sortable), n2.childNodes.forEach(
      (l2) => o.appendChild(l2)
    ), n2.appendChild(o), o.attachShadow({ mode: "open" }).appendChild(
      t.content.cloneNode(true)
    );
    const r = document.createElement("template");
    r.innerHTML = `
        <${this.getScopedTagName("beacon-icon-button")} slot="sort" variant="tertiary" data-beacon-sort>
          <svg data-metrics-link-text="Sort ascending" class="ascending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 3L12 8H8.5L8.5 13H7.5L7.5 8H4L8 3Z"/>
          </svg>
          <svg data-metrics-link-text="Sort descending" class="descending" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.5 8L8.5 3H7.5L7.5 8H4L8 13L12 8H8.5Z"
            />
          </svg>
          <svg class="default" slot="icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8 2L11 6H5L8 2ZM8 14L5 10H11L8 14Z" />
          </svg>
          <span class="sort-text">Sort</span>
        </${this.getScopedTagName("beacon-icon-button")}>
        `;
    const s2 = r.content.cloneNode(true);
    o.appendChild(s2);
    const c$1 = o.querySelector(
      this.getScopedTagName("beacon-icon-button")
    );
    c$1 == null || c$1.addEventListener(u$1.CLICK, () => {
      var l2;
      $(this, E, C(this, E) === c.ASCENDING ? c.DESCENDING : c.ASCENDING), L(l2 = i, T, V).call(l2, n2, C(this, E)), E$1(n2, u$1.SORT);
    });
  }), $(this, M, true);
}, D(i, T), i.tagName = ae.beaconTagName, i);
g([
  h({ reflect: true })
], p.prototype, "variant", 2);
g([
  h({ type: Boolean })
], p.prototype, "sortable", 2);
g([
  h({ type: Boolean, attribute: "use-cards" })
], p.prototype, "useCards", 2);
g([
  a()
], p.prototype, "hasMultiLevel", 2);
g([
  h({ attribute: "mobile-full-bleed", type: Boolean })
], p.prototype, "mobileFullBleed", 2);
g([
  h({ reflect: true })
], p.prototype, "density", 2);
g([
  h({ attribute: "static-header", type: Boolean, reflect: true })
], p.prototype, "staticHeader", 2);
g([
  a()
], p.prototype, "scrollPositionBlock", 2);
g([
  a()
], p.prototype, "scrollPositionInline", 2);
g([
  d(".table-container")
], p.prototype, "tableContainer", 2);
g([
  d(".transformed-cards")
], p.prototype, "_transformedCardsContainer", 2);
g([
  x("hasMultiLevel")
], p.prototype, "_setMultiLevelAttribute", 1);
g([
  x("isMediumBreakpoint")
], p.prototype, "_handleBreakpointChanges", 1);
g([
  x("useCards")
], p.prototype, "_handleCardChanges", 1);
g([
  x("sortable")
], p.prototype, "_handleSortChanges", 1);
let _e = p;
export {
  _e as BeaconTable
};
